<template>
  <div class="index-page">
    <div class="hero-card">
      <div class="hero-icon">🃏</div>
      <h1 class="hero-title">Planning Poker</h1>
      <p class="hero-subtitle">Estimate together, align faster</p>
      <form @submit.prevent="joinRoom" class="join-form">
        <div class="input-group">
          <input
            v-model="roomNumber"
            placeholder="Enter room name..."
            type="text"
            class="room-input"
            autofocus
          />
        </div>
        <button
          :disabled="roomNumber === ''"
          class="join-btn"
          type="submit"
        >
          <i class="fa fa-arrow-right"></i> Enter Room
        </button>
      </form>
      <p class="hint-text">No setup needed — just pick a name and share the link</p>

      <!-- Recent rooms -->
      <div v-if="recentRooms.length" class="recent-rooms">
        <p class="recent-label"><i class="fa fa-history"></i> Recent rooms</p>
        <div class="recent-chips">
          <button v-for="room in recentRooms" :key="room" class="room-chip" @click="goToRoom(room)">
            {{ room }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "Index",
  data: () => ({
    roomNumber: "",
    recentRooms: [],
  }),
  created() {
    try {
      const stored = localStorage.getItem('pp-recent-rooms')
      if (stored) {
        this.recentRooms = JSON.parse(stored).slice(0, 5)
      }
    } catch (e) { /* noop */ }
  },
  methods: {
    joinRoom: function () {
      const { roomNumber } = this;
      if (roomNumber) {
        this.saveRecentRoom(roomNumber)
        return this.$router.push({
          name: "room",
          params: { room: roomNumber },
        });
      }
    },
    goToRoom(room) {
      this.saveRecentRoom(room)
      this.$router.push({ name: "room", params: { room } })
    },
    saveRecentRoom(room) {
      try {
        let rooms = []
        const stored = localStorage.getItem('pp-recent-rooms')
        if (stored) rooms = JSON.parse(stored)
        rooms = [room, ...rooms.filter(r => r !== room)].slice(0, 5)
        localStorage.setItem('pp-recent-rooms', JSON.stringify(rooms))
      } catch (e) { /* noop */ }
    }
  },
});
</script>

<style scoped>
.index-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  flex: 1;
  background: var(--bg-primary);
  padding: 24px;
}

.hero-card {
  background: var(--panel-bg);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  padding: 48px 40px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: var(--shadow-lg);
}

.hero-icon {
  font-size: 3em;
  margin-bottom: 8px;
}

.hero-title {
  font-size: 1.8em;
  font-weight: bold;
  color: var(--text-primary);
  margin: 0 0 8px 0;
}

.hero-subtitle {
  color: var(--text-tertiary);
  margin: 0 0 32px 0;
  font-size: 0.9em;
}

.join-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.room-input {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid var(--input-border);
  background: var(--input-bg);
  border-radius: 10px;
  color: var(--text-primary);
  font-size: 0.95em;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
  box-sizing: border-box;
}

.room-input::placeholder {
  color: var(--text-tertiary);
}

.room-input:focus {
  border-color: var(--accent);
  background: var(--card-bg);
  box-shadow: 0 0 0 3px var(--accent-subtle);
}

.join-btn {
  width: 100%;
  padding: 12px;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 14px var(--accent-glow);
}

.join-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--accent-glow);
}

.join-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.hint-text {
  margin-top: 20px;
  font-size: 0.75em;
  color: var(--text-tertiary);
}

/* Recent rooms */
.recent-rooms {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

.recent-label {
  font-size: 0.72em;
  color: var(--text-tertiary);
  margin-bottom: 10px;
  font-weight: 500;
}

.recent-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.room-chip {
  background: var(--accent-subtle);
  color: var(--accent);
  border: 1px solid var(--accent-glow);
  border-radius: 16px;
  padding: 5px 14px;
  font-size: 0.8em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.room-chip:hover {
  background: var(--accent);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px var(--accent-glow);
}
</style>
